import { render, staticRenderFns } from "./NotificationsModule.vue?vue&type=template&id=cf2089ac&scoped=true"
import script from "./NotificationsModule.vue?vue&type=script&lang=js"
export * from "./NotificationsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2089ac",
  null
  
)

export default component.exports